<template>
  <div>
        <dropper :index="index" :level="2"></dropper>
        <div  v-if="$parent.editMode"  class="delete is-pulled-right" @click="remove"></div>
        <div ref="tit" class="has-text-coolGreen is-size-4 has-text-grey-white top10" :contenteditable="$parent.editMode" @focus="setDirty('tit')" @blur="update('tit')">
            <b :class="{cmsItemFocused: focused}">{{params.subtitle}}</b>
        </div>
  </div>
</template>

<script>

import dropper from './sectionDropper.vue'
import { AZEventBus } from '../AZEventBus'

export default {
    props: {params: Object, index: Number},
    components: {dropper},
    data: function(){
        return {
            dirty: '',
            focused: false
        }
    },

    methods: {
        update: function(t){
          this.focused = false;
          if(this.$refs[t].innerText != this.dirty){
            this.$parent.source[this.index].params.subtitle = this.$refs[t].innerText
            AZEventBus.$emit('pageChanged', null)
          }
        },

        remove: function(){
            this.$parent.removeSection(this.index)
        },

        setDirty: function(t){
            this.focused = true;
            this.dirty = this.$refs[t].innerText
        }
    }
}

</script>